import { alert, customDetail } from 'utils';
import { ERROR } from 'constants';

const commonErrorTip = ({ type = ERROR, title, caption = '详情说明：', detail, btnText = { confirm: '关闭' } }) => {
  const content = customDetail({ caption, detail, hasDot: true });
  return alert(type, title, btnText, content);
};

export default commonErrorTip;
